export default "__VITE_ASSET__CbIQqs79__"